import { ThemeColors } from "@/config/colors";
import { ReviewComment } from "@/features/misc/components/ReviewComment";
import { caremeTheme } from "@/libs/theme";
import type { NextPageWithLayout } from "@/pages/_app";
import {
	AppBar,
	Box,
	Button,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Toolbar,
	Typography,
} from "@mui/material";
import { Container } from "@mui/system";
import Image from "next/image";

const featureTableData = [
	{
		name: "パートナー共有",
		free: "一部",
		premium: "すべて",
	},
	{
		name: "特に妊娠しやすい日\n・気分の予測",
		free: "-",
		premium: "✔︎",
	},
	{
		name: "ホームカレンダー\n表示",
		free: "1ヶ月後まで",
		premium: "6ヶ月後まで",
	},
	{
		name: "生理日・妊娠しやすい日・排卵日の予測",
		free: "1ヶ月",
		premium: "6ヶ月",
	},
	{
		name: "排卵予定日\n通知",
		free: "-",
		premium: "✔︎",
	},
	{
		name: "テーマカラー",
		free: "一部",
		premium: "すべて",
	},
];

export const Premium: NextPageWithLayout = () => {
	return (
		<>
			<Container component="header" maxWidth="xs" style={{ padding: 0 }}>
				<Box
					px={2}
					height={64}
					display="flex"
					alignItems="center"
					justifyContent="space-between"
					bgcolor={ThemeColors[0].colors.primary[500]}
				>
					<Image
						src="/logo-white.png"
						width={130}
						height={27}
						alt="ケアミーのロゴ"
					/>
				</Box>
			</Container>

			<Container component="main" maxWidth="xs" style={{ padding: 0 }}>
				<Box px={3} pt={6} pb={10} bgcolor={ThemeColors[0].colors.primary[500]}>
					<Typography
						variant="h4"
						component="h1"
						fontWeight="700"
						textAlign="center"
					>
						ケアミープレミアム
					</Typography>

					<Button
						fullWidth
						variant="primaryLight"
						sx={{ mt: 3 }}
						href="/premium/purchase"
					>
						1週間無料でおためしする
					</Button>
				</Box>

				<Box
					display="flex"
					flexDirection={"column"}
					alignItems="center"
					mt={-2}
					px={3}
					sx={{
						backgroundImage: "url(./premium/rounded-background.png)",
						backgroundRepeat: "no-repeat",
						backgroundPositionY: "top",
						backgroundSize: "cover",
					}}
				>
					<Box px={3}>
						<Typography
							my={8}
							variant="h6"
							component="h2"
							fontWeight="700"
							textAlign="center"
							color={ThemeColors[0].colors.primary[600]}
						>
							ケアミープレミアムの特徴
						</Typography>
					</Box>

					<Image
						width={80}
						height={80}
						src={"/top/icon-talk-notification.png"}
						alt="カラダやココロの変化をLINEでパートナーに共有"
					/>

					<Typography
						mt={3}
						variant="h5"
						component="h2"
						fontWeight="700"
						textAlign="center"
					>
						カラダやココロの変化を
						<br />
						LINEでパートナーに共有
					</Typography>

					<Typography mt={3}>
						パートナー共有を使えば、カラダやココロの変化をパートナーに知ってもらうことができます。あなたの代わりにケアミーがパートナーのLINEに通知するので、PMSのことを自分の言葉でうまく説明できない、心理的にうまく伝えられないという方におすすめです。
					</Typography>

					<Box mt={11}>
						<Image
							width={80}
							height={80}
							src={"/top/icon-pairing-message.png"}
							alt="PMSの基礎知識を自動で通知"
						/>
					</Box>

					<Typography
						mt={3}
						variant="h5"
						component="h2"
						fontWeight="700"
						textAlign="center"
					>
						PMSの基礎知識を自動で通知
					</Typography>

					<Typography mt={3}>
						パートナー共有の通知には産婦人科医監修のPMSの基礎知識が添えられているので、パートナーにPMSのことを理解してもらえます。
					</Typography>

					<Box mt={11}>
						<Image
							width={80}
							height={80}
							src={"/top/icon-calendar.png"}
							alt="PMSを予測してカレンダーに表示"
						/>
					</Box>

					<Typography
						mt={3}
						variant="h5"
						component="h2"
						fontWeight="700"
						textAlign="center"
					>
						PMSを予測して
						<br />
						カレンダーに表示
					</Typography>

					<Typography mt={3}>
						不調になりやすい期間を予測してカレンダーに表示します。そろそろ生理前かな？と思ったらアプリを開くだけでパッとチェックできます。不調になりやすい期間をあらかじめ知ることができるので、スケジュール調整にも役立ちます。
					</Typography>
				</Box>

				<Box px={3} mt={16}>
					<Typography
						mt={8}
						variant="h6"
						component="h2"
						fontWeight="700"
						textAlign="center"
						color={ThemeColors[0].colors.primary[600]}
					>
						よろこびの声
					</Typography>

					<Box mt={8}>
						<ReviewComment
							title="カップルに絶対おすすめ"
							description="パートナー共有で共有するようになってから、わたしが生理前で情緒不安になっていることを彼が察してくれるようになりました！PMSのせいで険悪なムードになることも減ったので、パートナー共有を使って本当によかったです！カップルに本当におすすめです！"
						/>
					</Box>

					<Box mt={8}>
						<ReviewComment
							title="彼が理解してくれました"
							description="生理やPMSの基礎知識もケアミーが彼のLINEに送ってくれるので、PMSのことを理解してくれるようになりました。最近、生理やPMSについて彼が自分で調べてくれているのを知ったときはとても嬉しかったです。"
						/>
					</Box>

					<Box mt={8}>
						<ReviewComment
							title="わかってくれている安心感"
							description="彼から生理やPMSのことを共有してほしいと言われて、パートナー共有を使いはじめました。LINEに通知がくるので彼もチェックしやすくいようです。自分の状態を彼がわかってくれているという安心感があります。"
						/>
					</Box>

					<Box mt={8}>
						<ReviewComment
							title="PMSの傾向を把握できた"
							description="PMSの症状が出やすい期間を予測してくれるので、スケジュールの調整に役立っています。記録した症状や状態を振り返ることもできるので、自分のPMSをちゃんと理解したうえで、PMSと上手に付き合うことができるようになりました。"
						/>
					</Box>

					<Box mt={8}>
						<ReviewComment
							title="相談できて安心した"
							description="婦人科に行くべきかどうか迷っていたとき、相談チャットの機能を使いました。受診の目安などを詳しく教えてもらえて、不安が解消しました。生理やPMSのことで不安になったときに相談できるので、とても心強いです。"
						/>
					</Box>
				</Box>

				<Box px={3} mt={16} mb={8}>
					<Typography
						variant="h6"
						component="h2"
						fontWeight="700"
						textAlign="center"
						color={ThemeColors[0].colors.primary[600]}
					>
						機能のご紹介
					</Typography>

					<Box mt={8}>
						<TableContainer>
							<Table aria-label="simple table">
								<TableHead>
									<TableRow>
										<TableCell />
										<TableCell align="center">
											<Typography variant="caption" sx={{ letterSpacing: 0 }}>
												無料会員
											</Typography>
										</TableCell>
										<TableCell
											align="center"
											sx={{
												background: "rgba(55, 228, 182, 0.15)",
												borderRadius: "8px 8px 0 0",
											}}
										>
											<Typography
												variant="caption"
												fontWeight={700}
												sx={{
													letterSpacing: 0,
													color: ThemeColors[0].colors.primary[600],
												}}
											>
												ケアミー
												<br />
												プレミアム
											</Typography>
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{featureTableData.map((d) => (
										<TableRow key={d.name}>
											<TableCell
												component="th"
												scope="row"
												align="right"
												sx={{ maxWidth: "112px", letterSpacing: 0 }}
											>
												<Typography variant="caption" whiteSpace="pre-line">
													{d.name}
												</Typography>
											</TableCell>
											<TableCell align="center" padding="none">
												<Typography variant="caption" sx={{ letterSpacing: 0 }}>
													{d.free}
												</Typography>
											</TableCell>
											<TableCell
												align="center"
												padding="none"
												sx={{ background: "rgba(55, 228, 182, 0.15)" }}
											>
												{d.premium === "✔︎" ? (
													<Image
														src={"/check-icon-green.png"}
														width={22}
														height={24}
														alt="チェックマーク"
														style={{ verticalAlign: "middle" }}
													/>
												) : (
													<Typography
														variant="caption"
														fontWeight={700}
														sx={{
															letterSpacing: 0,
															color: ThemeColors[0].colors.primary[600],
														}}
													>
														{d.premium}
													</Typography>
												)}
											</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					</Box>
				</Box>
				<AppBar
					position="sticky"
					color="inherit"
					sx={{
						backgroundColor: caremeTheme.palette.primary.light,
						boxShadow: "none",
						top: "auto",
						bottom: 0,
						margin: 0,
					}}
				>
					<Toolbar>
						<Box width="100%" p={2}>
							<Button href="/premium/purchase" fullWidth variant="contained">
								1週間無料でおためしする
							</Button>
						</Box>
					</Toolbar>
				</AppBar>
			</Container>
		</>
	);
};
